import React, { useState, useEffect, useContext } from "react";
import { PartenerSheepDeedService } from "../services/parternshipservice";
import CitySelector from "./User/CitySelectore";
import { handleRazorpayPayment } from "../services/handlePayment";
import AuthUser from "../services/AuthUser";
import { ServicesContext } from "../services/ServicesContext";
import { useNavigate } from "react-router-dom";


const ItrPricingPlan = ({ tenures, features, price, title, onSubmit, add }) => {

  useEffect(() => {
    const storedUser = localStorage.getItem("user");
    if (storedUser) {
      const parsedUser = JSON.parse(storedUser);
      setNewData((prevData) => ({
        ...prevData,
        user_name: parsedUser.name || "",
        user_email: parsedUser.email || "",
        user_contact: parsedUser.mobile || "",
        user_city: parsedUser.city || "",
      }));
    }
  }, []);


  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [selectedTenure, setSelectedTenure] = useState(null);
  const [isFormVisible, setIsFormVisible] = useState(false); // Track if the form is visible
  const [isContentVisible, setIsContentVisible] = useState(true); // Track if the bottom content is visible
       const { http, token } = AuthUser();
   const navigate = useNavigate();
  const { services, loading, error } = useContext(ServicesContext);
  const service = services.find(s => s.service_id === 16);
  const toggleDropdown = () => setIsDropdownOpen((prev) => !prev);

  const selectTenure = (tenure) => {
    setSelectedTenure(tenure);
    setIsDropdownOpen(false);  // Close dropdown after selection
  };
  const [isChecked, setIsChecked] = useState(false);
  const finalPrice = isChecked ? parseInt(price) + parseInt(add) : parseInt(price);

  // Close dropdown if clicked outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (event.target.closest('.dropdown') === null) {
        setIsDropdownOpen(false);  // Close dropdown when clicking outside
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const handleGetStartedClick = () => {
    setIsFormVisible(true);  // Show the form when "Get Started" button is clicked
    setIsContentVisible(false);  // Hide content at the bottom
  };

  const handleCloseClick = () => {
    setIsFormVisible(false);  // Hide the form when "Close" button is clicked
    setIsContentVisible(true);  // Show content at the bottom
  };


  const [newData, setNewData] = useState({ plans: title, prize: finalPrice, user_name: '', user_email: '', user_contact: '', user_city: '' })

  const [errors, setErrors] = useState({});

  const validateForm = () => {
    const newErrors = {};



    if (!newData.user_name.trim()) {
      newErrors.user_name = '*Name is required.';
    } else if (!/^[a-zA-Z\s]+$/.test(newData.user_name)) {
      newErrors.user_name = '*Name should only contain letters and spaces.';
    }

    if (!newData.user_email.trim()) {
      newErrors.user_email = '*Email is required.';
    } else if (!/\S+@\S+\.\S+/.test(newData.user_email)) {
      newErrors.user_email = 'Enter a valid email address.';
    }
    if (!newData.user_contact.trim()) {
      newErrors.user_contact = '*number is required.';
    } else if (!/^\d{10}$/.test(newData.user_contact)) {
      newErrors.user_contact = 'Enter a valid 10-digit contact number.';
    }

    // if (newData.user_contact && !/^\d{10}$/.test(newData.user_contact)) {
    //   newErrors.user_contactr = '*Enter a valid 10-digit contact number.';
    // }

    if (!newData.user_city) {
      newErrors.user_city = '*City/District is required.';
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0; // No errors
  };

  const currentData = {
    plans: title,
    prize: finalPrice,
    user_name: newData.user_name,
    user_email: newData.user_email,
    user_contact: newData.user_contact,
    user_city: newData.user_city,
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
        // ✅ Check if user is logged in
        //   if (!token) {
      //      alert("Please log in to continue.");
      //    localStorage.setItem("redirectAfterLogin", window.location.pathname); // ⬅️ Save current path
      //     navigate('/login'); // 👈 Use this if you're using React Router
      //     return;
      //  }
    console.log("handleSubmit triggered"); // Debugging if function is triggered

    const isValid = validateForm();
    console.log("Validation result:", isValid);

    if (isValid) {
      // try {
      //   const currentData = {
      //     plans: title,
      //     prize: finalPrice,
      //     user_name: newData.user_name,
      //     user_email: newData.user_email,
      //     user_contact: newData.user_contact,
      //     user_city: newData.user_city,
      //   };

      //   console.log("Submitting data:", currentData); // Check data before sending

      //   const data = await PartenerSheepDeedService.itrFilingForm(currentData);
      //   console.log("Server Response:", data); // Debug API response

      //   setNewData({
      //     plans: title,
      //     prize: finalPrice,
      //     user_name: '',
      //     user_email: '',
      //     user_contact: '',
      //     user_city: '',
      //   });


       localStorage.setItem("bookingData", JSON.stringify(currentData));

      // Navigate to checkout
      navigate('/checkout', {
         state: {
            service: service,

         }
      });

      if (onSubmit) {
        console.log("onSubmit callback called");
        onSubmit(currentData);
      }





    } else {
      console.log("Form validation failed, submission blocked.");
    }
  };

  return (
    <div className="pricing-plan">
      <div className="price">
        <p className="pp-text">{title}</p>
        {isFormVisible && (
          <div class="wrapper">
            <button
              className="getStartdBn btn"
              onClick={isFormVisible ? handleCloseClick : handleGetStartedClick}
            >
              {isFormVisible ? "Close" : "GET STARTED"}
            </button>

          </div>
        )}


      </div>
      {/* <h1 className="d-inline-block"> Rs.{price}</h1><span>/Only</span> */}
      <p className="price-section">
        <span></span>Rs.{finalPrice}<span>/Only</span>

      </p>







      {/* Display form only when "Get Started" button is clicked */}
      {isFormVisible && (
        <div className="formContainer">
          <form>
            <div className="form-group">
              <label className="text-bold" htmlFor="name">Name</label>{errors.user_name && <p className="error">{errors.user_name}</p>}
              <input type="text" className="form-control" required value={newData.user_name} onChange={(e) => setNewData({ ...newData, user_name: e.target.value })} />
            </div>
            <div className="form-group">
              <label className="text-bold" htmlFor="email">Email</label> {errors.user_email && <p className="error">{errors.user_email}</p>}
              <input type="email" className="form-control" required value={newData.user_email} onChange={(e) => setNewData({ ...newData, user_email: e.target.value })} />
            </div>
            <div className="form-group">
              <label className="text-bold" htmlFor="mobile">Contact no</label> {errors.user_contact && <p className="error">{errors.user_contact}</p>}
              <input type="tel" className="form-control" required value={newData.user_contact} onChange={(e) => setNewData({ ...newData, user_contact: e.target.value })} />
            </div>
            <div className="form-group">
              <CitySelector
                newData={newData}
                setNewData={setNewData}
                fieldKey="user_city"
                errors={errors}
              />
            </div>
            <div className="btn-cont">


              <div class="wrapper">
                <button type="submit" className="getStartdBn btn" onClick={handleSubmit}>
                  Submit
                </button>
              </div>

            </div>
          </form>

        </div>
      )}

      {/* Show content only when it's visible */}
      {isContentVisible && (
        <div className="yttt">
          <div className="defaultText">

            <ul>
              {features.map((item, index) => {
                // Check if the item contains "Trading" or "Service Provider"
                const isTrading = item.includes("Trading");
                const isServiceProvider = item.includes("Service Provider");

                return (
                  <li key={index} className="text-bold">
                    {item !== "(Esitmated Turnover and Profit)" && (
                      <img src="assets/icons/check.svg" alt="" />
                    )}
                    {isTrading ? (
                      <>
                        Business Income - <span className="font-bold">Trading</span>
                      </>
                    ) : isServiceProvider ? (
                      <>
                        Business Income - <span className="font-bold">Service Provider</span>
                      </>
                    ) : (
                      item
                    )}
                  </li>
                );
              })}
            </ul>


          </div>

          <div class="wrapper">
            <button
              className="getStartdBn btn"
              onClick={isFormVisible ? handleCloseClick : handleGetStartedClick}
            >
              {isFormVisible ? "X" : "GET STARTED"}
            </button>

          </div>
          <div>

            <label style={{ display: "flex", gap: "10px", cursor: "pointer" }}>
              <input
                className="check"
                type="checkbox"
                checked={isChecked}
                onChange={() => setIsChecked(!isChecked)}
              />
              <span className="add-h">Add on : <span className="add">with P & L and Balance Sheet Preparation Rs.{add}/-</span></span>

            </label>

          </div>
        </div>
      )}

    </div>
  );
};

export default ItrPricingPlan;
